module.exports = __webpack_public_path__ + "img/Weapon_286.930358eb.png";